<template>
  <v-col
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg">
    <v-select
      v-model="vModel"
      v-bind="$attrs"
      v-on="$listeners"
      filled
      :rounded="!hasError"
      :outlined="hasError"
      hide-details
      class="my-input"
      color="#6A83B5"
      background-color="#F2F6FF"
      @update:error="errorChange"
      @blur="validateError">
      <template v-slot:label>
        <strong :class="hasError ? '' : 'custom-input-label-color'">
          {{ $attrs.label }}
        </strong>
      </template>
    </v-select>
  </v-col>
</template>

<script>
export default {
  name: 'CustomSelect',
  inheritAttrs: false,
  props: {
    value: {
      default() {
        return this.value || null;
      },
    },
    cols: {
      type: String,
      default: '12',
    },
    sm: {
      type: String,
      default() {
        return this.sm || this.cols;
      },
    },
    md: {
      type: String,
      default() {
        return this.md || this.sm;
      },
    },
    lg: {
      type: String,
      default() {
        return this.lg || this.md;
      },
    },
  },
  data() {
    return {
      hasError: false,
    };
  },
  methods: {
    validateError() {
      this.hasError = !this.value;
    },
    errorChange(event) {
      this.hasError = event;
    },
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">
.v-select__selections {
  color: #1B1BAF !important;;
  font-weight: 500 !important;
}
</style>
